import moment from 'moment';
class searchAppointmentController {
	$onInit() {
		this.doctorListCopy = [...this.doctorList];
		this.doctorlistPaginated = this.doctorListCopy.slice(0, this.elementsForPage);

		this.onChangeDate({
			values: [
				moment(new Date(new Date().setDate(new Date().getDate() + 0))),
				moment(new Date(new Date().setDate(new Date().getDate() + 1))),
				moment(new Date(new Date().setDate(new Date().getDate() + 2))),
			]
		});

	}
	$onChanges(changes) {
		if (changes.doctorList) {
			this.doctorList = [...this.doctorList];
			this.doctorListCopy = [...this.doctorList];
			this.totalElements = this.doctorListCopy.length;
			this.doctorlistPaginated = this.doctorListCopy.slice(0, this.elementsForPage);
			this.onChangeDate({
				values: [
					moment(new Date(new Date().setDate(new Date().getDate() + 0))).format('YYYY-MM-DD'),
					moment(new Date(new Date().setDate(new Date().getDate() + 1))).format('YYYY-MM-DD'),
					moment(new Date(new Date().setDate(new Date().getDate() + 2))).format('YYYY-MM-DD'),
				]
			});
		}
		if (changes.doctorListFilter) {
			this.doctorListFilter = { ...this.doctorListFilter
			};
		}
		if (changes.selectedPage) {
			this.selectedPage = this.selectedPage;
		}
		if (changes.elementsForPage) {
			this.elementsForPage = this.elementsForPage;
		}
	}
	onChangePagination({
		page
	}) {
		this.selectedPage = page;
		this.totalElements = this.doctorListCopy.length;
		const begin = ((this.selectedPage - 1) * this.elementsForPage);
		const end = begin + this.elementsForPage;
		this.doctorlistPaginated = this.doctorListCopy.slice(begin, end);
	}

	changeDoctorData(doctor, firstDay, secondDay, thirdDay) {
		doctor.firstDay = firstDay;
		doctor.secondDay = secondDay;
		doctor.thirdDay = thirdDay;

		const emptyDaysDistribution = Array.from(new Array(5), () => '-');
		if (!doctor.horary.hasOwnProperty(doctor.firstDay)) {
			doctor.horary[doctor.firstDay] = emptyDaysDistribution;
		}
		if (!doctor.horary.hasOwnProperty(doctor.secondDay)) {
			doctor.horary[doctor.secondDay] = emptyDaysDistribution;
		}
		if (!doctor.horary.hasOwnProperty(doctor.thirdDay)) {
			doctor.horary[doctor.thirdDay] = emptyDaysDistribution;
		}

		return doctor;
	}

	/**
	 * This function capture the Date values returned for Date selector component  
	 * and update the data for component Doctor list changing the value for attribute horary.
	 * If the dates selected dont be find in the  horary attribute, then it add the 
	 * new field in the attribute Horary.
	 * @param  {} {values}
	 * 
	 */
	onChangeDate({
		values
	}) {
		const firstDay = moment(values[0]).format('YYYY-MM-DD');
		const secondDay = moment(values[1]).format('YYYY-MM-DD');
		const thirdDay = moment(values[2]).format('YYYY-MM-DD');

		const temporalData = [...this.doctorList];
		temporalData.forEach(element => {
			element = this.changeDoctorData(element, firstDay, secondDay, thirdDay);
			return element;
		});
		this.doctorList = [...temporalData];
	}


	/**
	 * This function capture the values selected in the component Doctor filter 
	 * and call the function updateDataWithFilter() for update the Doctor List component data
	 * @param  {} {childrenOption
	 * @param  {} selectedDateRange
	 * @param  {} selectedGender
	 * @param  {} selectedHealthIssue
	 * @param  {} selectedLanguage
	 * @param  {} timeAfterOption
	 * @param  {} timeBeforeOption}
	 */
	onChangeFilter({
		childrenOption,
		selectedDateRange,
		selectedGender,
		selectedHealthIssue,
		selectedLanguage,
		timeAfterOption,
		timeBeforeOption
	}) {
		this.doctorListFilter = { ...this.doctorListFilter,
			childrenOption,
			selectedDateRange,
			selectedGender,
			selectedHealthIssue,
			selectedLanguage,
			timeAfterOption,
			timeBeforeOption,
		};
		this.updateDataWithFilter();
	}
	/**
	 * This function capture the value selected in order section on Doctor filter component
	 * and  order the Doctor List component data
	 * 
	 * @param  {} {sortBy}
	 */
	onChangeOrder({
		sortBy
	}) {

		this.doctorListFilter = { ...this.doctorListFilter,
			sortBy
		};
		this.updateDataWithFilter();
	}


	filterByGender(doctorList, gender) {
		const doctorListFiltered = doctorList.filter(item => {
			return (item.doctor.gender === gender) ? item : null
		});
		return doctorListFiltered;
	}
	checkNext3Days(doctor, firstDay, secondDay, thirdDay) {
		const filterFirsDay = doctor.horary[firstDay].filter(element => element !== '-');
		const filtersecondDay = doctor.horary[secondDay].filter(element => element !== '-');
		const filterthirdDay = doctor.horary[thirdDay].filter(element => element !== '-');
		return ((filterFirsDay && filterFirsDay.length > 0) || (filtersecondDay && filtersecondDay.length > 0) || (filterthirdDay && filterthirdDay.length > 0)) ? doctor : null;
	}

	filterByDateRange(doctorListCopy, dateRange) {
		let filterDataWithDate = [];
		const dates = [
			new Date(new Date().setDate(new Date().getDate() + 0)),
			new Date(new Date().setDate(new Date().getDate() + 1)),
			new Date(new Date().setDate(new Date().getDate() + 2))
		];
		const firstDay = moment(dates[0]).format('YYYY-MM-DD');
		const secondDay = moment(dates[1]).format('YYYY-MM-DD');
		const thirdDay = moment(dates[2]).format('YYYY-MM-DD');
		const auxData = doctorListCopy;

		if (dateRange === 0) {
			filterDataWithDate = auxData.filter(item => {
				const filter = item.horary[firstDay].filter(element => element !== '-');
				return (filter.length > 0) ? item : null
			})
			return filterDataWithDate;
		} else {
			filterDataWithDate = auxData.filter(item => {
				item = this.checkNext3Days(item, firstDay, secondDay, thirdDay);
				return item;
			});
			return filterDataWithDate;
		}
	}


	filterByHealthIssue(doctorListCopy, selectedHealthIssue) {
		const listFilterProcedure = doctorListCopy.filter(item => {
			const procedureFilter = item.procedures.find(element => element.id === selectedHealthIssue);
			return (procedureFilter) ? item : null;
		});
		return listFilterProcedure;
	}
	filterByselectedLanguage(doctorListCopy, selectedLanguage) {
		const listFilterLanguage = doctorListCopy.filter(item => {
			const languageFilter = item.languages.find(element => element.id === selectedLanguage);
			return (languageFilter) ? item : null;
		});
		return listFilterLanguage;
	}

	filterByChildrenOption(doctorListCopy, childrenOption) {
		doctorListCopy = doctorListCopy.filter(element => element.childrenOption === childrenOption);
		return doctorListCopy;
	}
	filterByTimeBeforeOption(doctorListCopy, timeBeforeOption) {
		doctorListCopy = doctorListCopy.filter(element => element.timeBeforeOption === timeBeforeOption);
		return doctorListCopy;
	}
	filterByTimeAfterOption(doctorListCopy, timeAfterOption) {
		doctorListCopy = doctorListCopy.filter(element => element.timeAfterOption === timeAfterOption);
		return doctorListCopy;
	}

	sortDoctorListData(doctorListCopy, sortBy) {
		let sortedList = [...doctorListCopy];
		if (sortBy === 'distance') {
			sortedList = sortedList.sort((a, b) => {
				return a.distance - b.distance
			});
		} else {
			sortedList = sortedList.sort((a, b) => {
				return a.majorAvailableDate - b.majorAvailableDate
			});
		}
		return sortedList
	}


	/**
	 * This function update the data for Doctor list component 
	 * using the object doctor List Filter updated previously. 
	 */
	updateDataWithFilter() {
		const {
			selectedGender,
			selectedDateRange,
			childrenOption,
			selectedLanguage,
			timeBeforeOption,
			timeAfterOption
		} = this.doctorListFilter;
		const gender = (selectedGender === 'f') ? 0 : ((selectedGender === 'm') ? 1 : -1)
		const dateRange = (selectedDateRange === 'today') ? 0 : ((selectedDateRange === 'next') ? 1 : -1)
		this.doctorListCopy = [...this.doctorList];

		if (gender !== -1) {
			this.doctorListCopy = [...this.filterByGender(this.doctorList, gender)];
		}

		if (dateRange !== -1) {
			this.doctorListCopy = [...this.filterByDateRange(this.doctorListCopy, dateRange)];
		}

		if (this.doctorListFilter.selectedHealthIssue !== 'any') {
			this.doctorListCopy = [...this.filterByHealthIssue(this.doctorListCopy, this.doctorListFilter.selectedHealthIssue)];
		}

		if (selectedLanguage !== 'any') {
			this.doctorListCopy = [...this.filterByselectedLanguage(this.doctorListCopy, selectedLanguage)];
		}
		if (childrenOption) {
			this.doctorListCopy = [...this.filterByChildrenOption(this.doctorListCopy, childrenOption)];
		}
		if (timeBeforeOption) {
			this.doctorListCopy = [...this.filterByTimeBeforeOption(this.doctorListCopy, timeBeforeOption)];
		}
		if (timeAfterOption) {
			this.doctorListCopy = [...this.filterByTimeAfterOption(this.doctorListCopy, timeAfterOption)];
		}

		if (this.doctorListFilter.sortBy !== 'default') {
			this.doctorListCopy = [...this.sortDoctorListData(this.doctorListCopy, this.doctorListFilter.sortBy)];
		}

		this.onChangePagination({
			page: 1
		});
	}
}

export default searchAppointmentController;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/search-appointment/search-appointment.controller.js